
import { computed, defineComponent } from 'vue'
import Message from '../interfaces/Message.interface'
import { useStore } from '../store'

export default defineComponent({
    name: "Message",
    props: {
        message: {
            required: true,
            type: Object as () => Message
        }
    },
    setup(props){
        const store = useStore()
        const isAuthor = computed(() => {
            return store.getters.getUser.userId === props.message.userId
        })

        return{
            isAuthor
        }
    }
})
